import { useEffect } from 'react';

const SITE = 'Tønsberg Seilforening';

const usePageTitle = (title?: string) => {
  useEffect(() => {
    document.title = title ? `${title} – ${SITE}` : SITE;
    return () => {
      document.title = SITE;
    };
  }, [title]);
};

export default usePageTitle;
